export const GA_API_KEY = 'AIzaSyB8D57FwaYlSqKkNAqHsIp6n8KKcF6o0L0'
export const GA_PROJECT_ID = 'awesome-bridge-mobile'
export const GA_MESSAGING_SENDER_ID = '631298072311'
export const GA_APP_ID = '5e0861ed414258d1a1bdf2'
export const GA_MEASUREMENT_ID = 'G-PFK1S1241P'
